module.exports = __webpack_public_path__ + "img/equityIcon5.9f01f958.png";